export const isMigrationInstance = () => {
  // In the migration instance, the application is hosted under 'myaccount.juliusbaer.com/migration'
  return window.location.hostname.includes('myaccount');
};
